import AuditoryOcularSR from 'libs/shared/ui/src/lib/components/my-evolution/auditoryAndOcular/auditoryAndOcular'

export const AuditoryOcular = () => {
  return (
    <div className="mt-10 w-full">
      <AuditoryOcularSR />
    </div>
  )
}
